import styled from "styled-components";
import ThemeSwitcher from "../Theme/ThemeSwitcher";
import MenuBurger from "./MenuBurger";
import {useContext} from "react";
import {MenuContext} from "../../contexts/MenuContext";
import {motion} from "framer-motion";
import Flex from "../UI/Flex";
import CollapseMenu from "../UI/CollapseMenu/CollapseMenu";
import CollapseItem from "../UI/CollapseMenu/CollapseItem";
import SwitcherCheckbox from "../UI/Checkboxes/SwitcherCheckbox";

const StyledMenu = styled.div`
  position: relative;
  padding: 20px 5px;
  top: 0;
  left: 0;
  width: 80px;
  max-width: 100vw;
  min-height: 100vh;
  background: ${props => props.theme.colors.secondary};
  z-index: 10;
`

const menuVariants = {
  open: {
    width: "400px",
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  },
  closed: {
    width: "80px",
    transition: {
      staggerChildren: 0.1,
      staggerDirection: -1
    }
  }
}

const Menu = () => {
  const {menuOpen, toggleMenu} = useContext(MenuContext);

  return (
    <StyledMenu
      as={motion.div}
      variants={menuVariants}
      animate={menuOpen ? "open" : "closed"}
    >
      <MenuBurger open={menuOpen} onChange={toggleMenu} />
      <Flex direction={"column"}>
        <CollapseMenu title={'Dropdown Title 1'}>
            <CollapseItem>
              <ThemeSwitcher/>
            </CollapseItem>
            <CollapseItem>
              <SwitcherCheckbox />
            </CollapseItem>
            <CollapseItem>
              <SwitcherCheckbox />
            </CollapseItem>
            <CollapseItem>
              <SwitcherCheckbox />
            </CollapseItem>
            <CollapseItem>
              <SwitcherCheckbox />
            </CollapseItem>
            <CollapseItem>
              <SwitcherCheckbox />
            </CollapseItem>
        </CollapseMenu>
      </Flex>
    </StyledMenu>
  );
};

export default Menu;